import React, { useEffect, useRef } from "react";

import "./EwayBill.css";
import { useState } from "react";
import dateformater from "../utils/dateformater";
import { useDispatch } from "react-redux";
import axios from "axios";

const EwayBill = () => {
  const dispatch = useDispatch();
  const gstin_auth = window.localStorage.getItem("gstin");
  // const [ewayBill, setewayBill] = useState({
  //   supplyType: "",
  //   subSupplyType: "",
  //   docType: "",
  //   docNo: "",
  //   docDate: "",
  //   transactionType: "",  //transactionType
  //   fromTrdName: "", //fromTrdName
  //   fromGstin: "",  //fromGstin
  //   actFromStateCode: "",//actFromStateCode
  //   fromAddr1: "", //fromAddr1 ,fromAddr2
  //   fromPlace: "",//fromPlace
  //   fromPincode: 0, //fromPincode
  //   fromStateCode: 0, //fromStateCode
  //   toTrdName: "", //toTrdName
  //   toGstin: "", //toGstin
  //   actToStateCode: 0, //actToStateCode
  //   toAddr1: "", //toAddr1 ,toAddr2
  //   toPlace: "", //toPlace
  //   toPincode: 0, //toPincode
  //   toStateCode: "",//toStateCode

  //   productName: "", //productName
  //   productDesc: "", //productDesc
  //   hsnCode: "", //hsnCode
  //   quantity: "", //quantity
  //   qtyUnit: "", //qtyUnit
  //   taxableAmount: "", //taxableAmount
  //   Item_Details_CGST_SGST_Rate: "",//sgstRate
  //   igstRate: "", //igstRate
  //   Item_Details_CESS_Advol_Rate: "",//cgstRate
  //   Item_Details_CESS_NonAdvol_Rate: "",//cessRate

  //   Item_Details_Total_Taxble_Amount: "",
  //   Item_Details_CGST_Amount: "",
  //   Item_Details_SGST_Amount: "",
  //   Item_Details_IGST_Amount: "",
  //   Item_Details_CESS_Advol_Amount: "",
  //   Item_Details_CESS_NonAdvol_Amount: "",
  //   Item_Details_Other_Amount: "",
  //   totInvValue: "",

  //   Transporter_Id: "",
  //   Transporter_Name: "",
  //   transDistance: "",//transDistance
  //   transMode: "", //transMode
  //   vehicleNo: "",//vehicleNo
  //   vehicleType: "",//vehicleType
  //   transDocNo: "",//transDocNo
  //   transDocDate: "", //transDocDate
  // });
  const [ewayBill, setewayBill] = useState({
    supplyType: "",
    subSupplyType: "",
    docType: "",
    docNo: "",
    docDate: "",
    transactionType: 0,
    fromTrdName: "",
    fromGstin: "",
    actFromStateCode: 0,
    fromAddr1: "",
    fromPlace: "",
    fromPincode: 0,
    fromStateCode: 0,
    toTrdName: "",
    toGstin: "",
    actToStateCode: "",
    toAddr1: "",
    toPlace: "",
    toPincode: 0,
    toStateCode: "",

    rate: "",
    productName: "",
    productDesc: "",
    hsnCode: "",
    quantity: "",
    qtyUnit: "",
    taxableAmount: "",
    sgstRate: 0,
    igstRate: 0,
    cessRate: 0,
    cessNonAdvol: 0,

    totalValue: 0,
    cgstValue: 0,
    sgstValue: 0,
    igstValue: 0,
    cessValue: 0,
    TolNonAdolVal: 0,
    OthValue: 0,
    totInvValue: "",

    transporterId: "",
    transporterName: "",
    transDistance: "",
    transMode: "",
    vehicleNo: "",
    vehicleType: "",
    transDocNo: "",
    transDocDate: "",
  });
  const [jsonData, setjsonData] = useState({});
  const handleChange = (e) => {
    setewayBill({ ...ewayBill, [e.target.name]: e.target.value });
  };
  const [ip, setIp] = useState("");
  useEffect(() => {
    getUserIp();
  }, []);
  const getUserIp = async () => {
    const ip = await axios.get("https://ipapi.co/json");
    setIp(ip.data.ip);
  };
  // Distance between 2 pincodes

  //const API_KEY = "AIzaSyC2Yw_3LtEEYVZ-WIra4tK-vjLwOXAwaoE"; // replace with your actual API key
  //const API_URL = `${process.env.REACT_APP_BACKEND_URL}maps`;
  const fetchData = async () => {
    try {
      const response = await fetch(
        "https://tame-jade-earthworm-belt.cyclic.app/maps?from=" +
          ewayBill.fromPincode +
          "&to=" +
          ewayBill.toPincode
      );
      console.log(response);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();

      if (data.status === "OK") {
        const distanceValue = data.rows[0].elements[0].distance.value;
        setewayBill((prevdetails) => ({
          ...prevdetails,
          transDistance: Math.round(distanceValue / 1000),
        })); // convert to kilometers
      } else {
        console.error("Error:", data.status);
        setewayBill((prevdetails) => ({
          ...prevdetails,
          transDistance: 0,
        }));
      }
    } catch (error) {
      console.error("Error:", error);
      setewayBill((prevdetails) => ({
        ...prevdetails,
        transDistance: 0,
      }));
    }
  };

  useEffect(() => {
    if (ewayBill.fromPincode > 100000 && ewayBill.toPincode > 100000) {
      fetchData();
    }
  }, [ewayBill.fromPincode, ewayBill.toPincode]);

  // calculation testing
  useEffect(() => {
    if (ewayBill.rate !== "" && ewayBill.quantity !== "") {
      const total = ewayBill?.rate * ewayBill?.quantity;
      setewayBill((prevdetails) => ({
        ...prevdetails,
        taxableAmount: total.toFixed(2),
        totalValue: total.toFixed(2),
      }));
    }
  }, [ewayBill.rate, ewayBill.quantity]);

  useEffect(() => {
    if (
      ewayBill.sgstRate !== "" &&
      ewayBill.taxableAmount !== "" &&
      ewayBill.igstRate !== "" &&
      ewayBill.cessRate !== "" &&
      ewayBill.cessNonAdvol !== ""
    ) {
      const cgv = (ewayBill.sgstRate * ewayBill.taxableAmount) / 100;
      const igv = (ewayBill.igstRate * ewayBill.taxableAmount) / 100;
      const cesv = (ewayBill.cessRate * ewayBill.taxableAmount) / 100;
      const cess_nonadvol = ewayBill.cessNonAdvol * ewayBill.quantity;
      setewayBill((prevdetails) => ({
        ...prevdetails,
        cgstValue: cgv.toFixed(2),
        sgstValue: cgv.toFixed(2),
        igstValue: igv.toFixed(2),
        cessValue: cesv.toFixed(2),
        TolNonAdolVal: cess_nonadvol.toFixed(2),
      }));
    }
  }, [
    ewayBill.sgstRate,
    ewayBill.taxableAmount,
    ewayBill.igstRate,
    ewayBill.cessRate,
    ewayBill.cessNonAdvol,
  ]);

  useEffect(() => {
    if (
      ewayBill.sgstValue !== "" &&
      ewayBill.taxableAmount !== "" &&
      ewayBill.igstValue !== "" &&
      ewayBill.cessValue !== "" &&
      ewayBill.TolNonAdolVal !== ""
    ) {
      const total_value =
        Number(ewayBill.taxableAmount) +
        Number(ewayBill.cgstValue) +
        Number(ewayBill.sgstValue) +
        Number(ewayBill.igstValue) +
        Number(ewayBill.cessValue) +
        Number(ewayBill.TolNonAdolVal) +
        Number(ewayBill.OthValue);
      setewayBill((prevdetails) => ({
        ...prevdetails,
        totInvValue: total_value.toFixed(2),
      }));
    }
  }, [
    ewayBill.sgstValue,
    ewayBill.taxableAmount,
    ewayBill.igstValue,
    ewayBill.cessValue,
    ewayBill.TolNonAdolVal,
    ewayBill.OthValue,
  ]);

  // const handleSubmit = async (event) => {

  //   console.log("ewaybill", ewayBill);
  //   const body = JSON.stringify({
  //     supplyType: ewayBill.supplyType,
  //     subSupplyType: ewayBill.subSupplyType,
  //     // "docType": "INV",
  //     docType: ewayBill.docType,
  //     docNo: ewayBill.docNo,
  //     docDate: dateformater(),
  //     fromGstin: ewayBill.fromGstin,
  //     // fromTrdName: ewayBill.fromTrdName,
  //     fromPlace: ewayBill.fromPlace,
  //     // fromAddr1: ewayBill.fromAddr1,
  //     fromStateCode: Number(ewayBill.actFromStateCode),
  //     fromPincode: Number(ewayBill.fromPincode),
  //     actFromStateCode: Number(ewayBill.fromStateCode),
  //     toGstin: ewayBill.toGstin,
  //     toPlace: ewayBill.toPlace,
  //     toPincode: Number(ewayBill.toPincode),
  //     toStateCode: Number(ewayBill.actToStateCode),
  //     actToStateCode: Number(ewayBill.toStateCode),
  //     transactionType: Number(ewayBill.transactionType),
  //     totInvValue: Number(ewayBill.totInvValue),
  //     transMode: ewayBill.transMode,
  //     transDistance: ewayBill.transDistance,
  //     // vehicleNo: "APR3214",
  //     vehicleNo: ewayBill.vehicleNo,
  //     transDocNo: ewayBill.transDocNo,
  //     transDocDate: dateformater(),
  //     itemList: [
  //       {
  //         productName: ewayBill.productName,
  //         productDesc: ewayBill.productDesc,
  //         // "quantity":Number(ewayBill.quantity),
  //         // "qtyUnit":ewayBill.qtyUnit,
  //         hsnCode: ewayBill.hsnCode,
  //         taxableAmount: Number(ewayBill.taxableAmount),
  //         // taxableAmount: 56099,
  //         sgstRate: Number(ewayBill.sgstRate),
  //         cgstRate: Number(ewayBill.sgstRate),
  //         igstRate: Number(ewayBill.igstRate),
  //         cessRate: Number(ewayBill.cessRate),
  //         cessNonAdvol: Number(ewayBill.cessNonAdvol),
  //       },
  //     ],
  //   });
  //   console.log("body", body);
  //   event.preventDefault();
  //   console.log(ewayBill);
  //   // getEwayBill();
  //   const response = await fetch(
  //     `https://api.mastergst.com/ewaybillapi/v1.03/ewayapi/genewaybill?email=sachin.123.kumar.456%40gmail.com`,
  //     {
  //       method: "POST",
  //       headers: {
  //         mode: "no-cors",
  //         ip_address: "136.233.9.105",
  //         client_id: "a6f557d6-4b96-4c29-8fc6-0e53362c1173",
  //         client_secret: "1fce9476-1cf3-451d-9c0b-79622100dc47",
  //         gstin: "05AAACH6188F1ZM",
  //         "Content-Type": "application/json",
  //       },
  //       body: body,
  //     }

  //   )
  //     .then((res) => {
  //       return res.json();
  //     })
  //     .then(async (json) => {
  //       // console.log("json : ", json);
  //       setjsonData(json);

  //       if (json.status_cd === "1") {
  //         console.log("success");
  //         prompt("Eway-Bill Number is ", `${json.data.ewayBillNo}`);
  //       } else {
  //         alert("Eway-Bill Number is not generated");
  //       }
  //       const finalNumber = json.data.ewayBillNo;
  //       const response2 = await fetch(
  //         `${process.env.REACT_APP_BACKEND_URL}/eway/`,
  //         {
  //           method: "POST",
  //           headers: {
  //             mode: "no-cors",
  //             "Content-Type": "application/json",
  //             auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
  //           },
  //           body: JSON.stringify({ ewaybillno: finalNumber }),
  //         }
  //       );
  //       const json2 = await response2.json();
  //       await fetch(`https://tame-jade-earthworm-belt.cyclic.app/ewayform`, {
  //         method: "POST",
  //         mode: "no-cors",
  //         headers: {

  //           "Content-Type": "application/json",
  //           auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
  //         },
  //         body: {
  //           // supplyType: ewayBill.supplyType,
  //           // docNo: "1",
  //         },
  //       });
  //     })

  //     .catch((err) => {
  //       console.log("err", err);
  //     });
  // };

  const handleSubmit = async (event) => {
    try {
      console.log("ewaybill in ewaybill.js", ewayBill);
      const body = JSON.stringify({
        supplyType: ewayBill.supplyType,
        subSupplyType: ewayBill.subSupplyType,
        // "docType": "INV",
        docType: ewayBill.docType,
        docNo: ewayBill.docNo,
        docDate: dateformater(),
        fromGstin: ewayBill.fromGstin,
        // fromTrdName: ewayBill.fromTrdName,
        fromPlace: ewayBill.fromPlace,
        // fromAddr1: ewayBill.fromAddr1,
        actFromStateCode: Number(ewayBill.actFromStateCode),
        fromPincode: Number(ewayBill.fromPincode),
        fromStateCode: Number(ewayBill.fromStateCode),
        toGstin: ewayBill.toGstin,
        toPlace: ewayBill.toPlace,
        toPincode: Number(ewayBill.toPincode),
        actToStateCode: Number(ewayBill.actToStateCode),
        toStateCode: Number(ewayBill.toStateCode),
        transactionType: Number(ewayBill.transactionType),
        totInvValue: Number(ewayBill.totInvValue),
        transMode: ewayBill.transMode,
        transDistance: ewayBill.transDistance,
        // vehicleNo: "APR3214",
        vehicleNo: ewayBill.vehicleNo,
        transDocNo: ewayBill.transDocNo,
        transDocDate: dateformater(),
        itemList: [
          {
            productName: ewayBill.productName,
            productDesc: ewayBill.productDesc,
            // "quantity":Number(ewayBill.quantity),
            // "qtyUnit":ewayBill.qtyUnit,
            hsnCode: ewayBill.hsnCode,
            taxableAmount: Number(ewayBill.taxableAmount),
            // taxableAmount: 56099,
            sgstRate: Number(ewayBill.sgstRate),
            cgstRate: Number(ewayBill.sgstRate),
            igstRate: Number(ewayBill.igstRate),
            cessRate: Number(ewayBill.cessRate),
            cessNonAdvol: Number(ewayBill.cessNonAdvol),
          },
        ],
      });
      console.log("body", body);
      event.preventDefault();
      console.log(ewayBill);
      const response = await fetch(
        `https://api.mastergst.com/ewaybillapi/v1.03/ewayapi/genewaybill?email=sachin.123.kumar.456%40gmail.com`,
        {
          method: "POST",
          headers: {
            mode: "no-cors",
            ip_address: ip,
            client_id: "e089a9b4-724d-4958-98d7-4a24f5b96d5c",
            client_secret: "a38ad362-aa30-4e74-bbef-cc075ef6c4e4",
            //client_id: "a6f557d6-4b96-4c29-8fc6-0e53362c1173",
            //client_secret: "1fce9476-1cf3-451d-9c0b-79622100dc47",
            gstin: gstin_auth,
            "Content-Type": "application/json",
          },
          body: body,
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const json = await response.json();
      setjsonData(json);
      if (json.status_cd === "1") {
        console.log("success");
        prompt("Eway-Bill Number is ", `${json.data.ewayBillNo}`);
      } else {
        alert("Eway-Bill Number is not generated", `${json.error.error_cd}`);
      }
      const finalNumber = json.data.ewayBillNo;
      const response2 = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/eway/`,
        {
          method: "POST",
          headers: {
            mode: "no-cors",
            "Content-Type": "application/json",
            auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
          },
          body: JSON.stringify({ ewaybillno: finalNumber }),
        }
      );
      if (!response2.ok) {
        throw new Error("Network response was not ok");
      }
      const json2 = await response2.json();

      const response3 = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}ewayform/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
          },
          body: JSON.stringify({
            supplyType: ewayBill.supplyType,
            subSupplyType: ewayBill.subSupplyType,
            docType: ewayBill.docType,
            docNo: ewayBill.docNo,
            docDate: dateformater(),
            transactionType: ewayBill.transactionType,
            fromTrdName: ewayBill.fromTrdName,
            fromGstin: ewayBill.fromGstin,
            actFromStateCode: ewayBill.actFromStateCode,
            fromAddr1: ewayBill.fromAddr1,
            fromPlace: ewayBill.fromPlace,
            fromPincode: ewayBill.fromPincode,
            fromStateCode: ewayBill.fromStateCode,
            toTrdName: ewayBill.toTrdName,
            toGstin: ewayBill.toGstin,
            actToStateCode: ewayBill.actToStateCode,
            toAddr1: ewayBill.toAddr1,
            toPlace: ewayBill.toPlace,
            toPincode: ewayBill.toPincode,
            toStateCode: ewayBill.toStateCode,
            productName: ewayBill.productName,
            productDesc: ewayBill.productDesc,
            hsnCode: ewayBill.hsnCode,
            quantity: ewayBill.quantity,
            qtyUnit: ewayBill.qtyUnit,
            taxableAmount: ewayBill.taxableAmount,
            sgstRate: ewayBill.sgstRate,
            igstRate: ewayBill.igstRate,
            cessRate: ewayBill.cessRate,
            cessNonAdvol: ewayBill.cessNonAdvol,
            totalValue: ewayBill.totalValue,
            cgstValue: ewayBill.cgstValue,
            sgstValue: ewayBill.cgstValue,
            igstValue: ewayBill.igstValue,
            cessValue: ewayBill.cessValue,
            TolNonAdolVal: ewayBill.TolNonAdolVal,
            OthValue: ewayBill.OthValue,
            totInvValue: ewayBill.totInvValue,
            transporterId: ewayBill.transporterId,
            transporterName: ewayBill.transporterName,
            transDistance: ewayBill.transDistance,
            transMode: ewayBill.transMode,
            vehicleNo: ewayBill.vehicleNo,
            vehicleType: ewayBill.vehicleType,
            transDocNo: ewayBill.transDocNo,
            transDocDate: ewayBill.transDocDate,
            ewayBillDate: json.data.ewayBillDate,
            validUpto: json.data.validUpto,
            eWay_Bill_No: json.data.ewayBillNo,
          }),
        }
      );
      if (!response3.ok) {
        throw new Error("Network response was not ok for response 3");
      }
    } catch (error) {
      console.error("Error occurred: ", error);
    }
  };
  const handleEwaybillSubmit = async (event) => {
    event.preventDefault();
    try {
      const response3 = await fetch(
        // `https://tame-jade-earthworm-belt.cyclic.app/ewayform`,
        `${process.env.REACT_APP_BACKEND_URL}ewayform`,
        {
          method: "POST",
          mode: "no-cors",
          header: {
            "Content-Type": "application/json",
            auth_token: "Bearer " + sessionStorage.getItem("user_auth_token"),
          },
          body: JSON.stringify({
            // supplyType: ewayBill.supplyType,
            docNo: "1",
          }),
        }
      );
      if (!response3.ok) {
        throw new Error("Network response was not ok for response 3");
      }
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    console.log("jsonData in useEffect :", jsonData);

    window.localStorage.setItem("ewayBillJson", JSON.stringify(ewayBill));

    window.localStorage.setItem("jsonData", JSON.stringify(jsonData));
  }, [jsonData, ewayBill]);

  const [temp, setTemp] = useState(false);
  const tempChange1 = () => {
    setTemp(false);
  };
  const tempChange2 = () => {
    setTemp(true);
  };
  let componentRef = useRef();
  return (
    <div className="container1">
      <form
        id="Ewaybill"
        onSubmit={handleSubmit}
        // onSubmit={handleEwaybillSubmit}
      >
        <div>
          {/* <div className="heading">
          <div className="left">
            <div className="left-img">
              <img src={logo} alt="" />
            </div>
            <div className="left-heading">
              <h3>Goods and Service Tax</h3>
              <h3>e-Way Bill System</h3>
            </div>
          </div>
          <div className="right-logo">
            <img src={rightlogo} alt="" />
            <img src={rightlogo2} alt="" />
          </div>
        </div> */}
          <div className="toolbar"></div>
          <h3 className="mainText">Transaction Details</h3>
          <div className="first">
            <div className="first-p">
              <p>Supply Type*</p>
            </div>
            <div className="Transaction-left">
              <label htmlFor="supplyType">Outward</label>
              <input
                type="radio"
                name="supplyType"
                id="Outward"
                required="required"
                onChange={handleChange}
                onClick={() => {
                  tempChange1();
                  console.log("temp1", temp);
                }}
                value="O"
              />
              <label htmlFor="supplyType">Inward</label>
              <input
                type="radio"
                name="supplyType"
                id="Inward  "
                onChange={handleChange}
                onClick={() => {
                  tempChange2();
                  console.log("temp2", temp);
                }}
                value="I"
              />
            </div>
            <div className="first-p">
              {" "}
              <p>Sub Type*</p>
            </div>
            <div
              className="Transaction-right"
              style={{
                display: `${temp ? "none" : "flex"}`,
              }}
            >
              <label htmlFor="subSupplyType">Supply</label>
              <input
                required="required"
                type="radio"
                name="subSupplyType"
                id="Supply"
                onChange={handleChange}
                value="1"
              />

              <label htmlFor="subSupplyType">Export</label>
              <input
                type="radio"
                name="subSupplyType"
                id="Export  "
                value="3"
                onChange={handleChange}
              />
              <label htmlFor="subSupplyType">Job Work</label>
              <input
                type="radio"
                name="subSupplyType"
                id="Job Work  "
                value="4"
                onChange={handleChange}
              />
              <label htmlFor="subSupplyType">SKD/CKD/Lots</label>
              <input
                type="radio"
                name="subSupplyType"
                id="SKD/CKD/Lots  "
                value="9"
                onChange={handleChange}
              />
              <label htmlFor="subSupplyType">Recipient Not Known</label>
              <input
                type="radio"
                name="subSupplyType"
                id="Recipient_Not_Known  "
                value="11"
                onChange={handleChange}
              />
              <label htmlFor="subSupplyType">For Own Use</label>
              <input
                type="radio"
                name="subSupplyType"
                id="For_Own_Use "
                value="5"
                onChange={handleChange}
              />
              <label htmlFor="subSupplyType">Exhibition or Fairs</label>
              <input
                type="radio"
                name="subSupplyType"
                id="Exhibition_or_Fairs"
                value="12"
                onChange={handleChange}
              />
              <label htmlFor="subSupplyType">Line Sales</label>
              <input
                type="radio"
                name="subSupplyType"
                id="Line_Sales"
                value="10"
                onChange={handleChange}
              />
              <label htmlFor="subSupplyType">Other</label>
              <input
                type="radio"
                name="subSupplyType"
                id="Other  "
                value="8"
                onChange={handleChange}
              />
            </div>
            <div
              style={{
                display: `${temp ? "flex" : "none"}`,
              }}
              className="Transaction-right-Inword"
            >
              <label htmlFor="subSupplyType">Supply</label>
              <input
                required="required"
                type="radio"
                name="subSupplyType"
                id="Supply"
                onChange={handleChange}
                value="1"
              />

              <label htmlFor="subSupplyType">Import</label>
              <input
                type="radio"
                name="subSupplyType"
                id="Import  "
                value="2"
                onChange={handleChange}
              />
              <label htmlFor="subSupplyType">Job Work Return</label>
              <input
                type="radio"
                name="subSupplyType"
                id="Job Work Return  "
                value="6"
                onChange={handleChange}
              />
              <label htmlFor="subSupplyType">SKD/CKD/Lots</label>
              <input
                type="radio"
                name="subSupplyType"
                id="SKD/CKD/Lots  "
                value="9"
                onChange={handleChange}
              />
              <label htmlFor="subSupplyType">Sales Return</label>
              <input
                type="radio"
                name="subSupplyType"
                id="Sales_Return "
                value="7"
                onChange={handleChange}
              />
              <label htmlFor="subSupplyType">For Own Use</label>
              <input
                type="radio"
                name="subSupplyType"
                id="For_Own_Use "
                value="5"
                onChange={handleChange}
              />
              <label htmlFor="subSupplyType">Exhibition or Fairs</label>
              <input
                type="radio"
                name="subSupplyType"
                id="Exhibition_or_Fairs"
                value="12"
                onChange={handleChange}
              />

              <label htmlFor="subSupplyType">Other</label>
              <input
                type="radio"
                name="subSupplyType"
                id="Other  "
                value="8"
                onChange={handleChange}
              />
            </div>
          </div>
          <div className="second">
            <div>
              <label htmlFor="docType">Document Type*</label>
              <select
                className="selectt"
                name="docType"
                required="required"
                id="document-type"
                onChange={handleChange}
                value={ewayBill.docType}
              >
                <option value="" name="docType">
                  -----
                </option>
                <option value="INV" name="docType">
                  Tax Invoice
                </option>
                <option value="BIL" name="docType">
                  Bill of Supply
                </option>
                <option value="BOE" name="docType">
                  Bill of Entry
                </option>
                <option value="CHL" name="docType">
                  Delivery Challan
                </option>
                <option value="OTH" name="docType">
                  Other
                </option>
              </select>
            </div>
            <div>
              <label htmlFor="docNo">Document No*</label>
              <input
                type="text"
                required="required"
                name="docNo"
                onChange={handleChange}
                value={ewayBill.docNo}
              />
            </div>
            <div>
              <label htmlFor="Document Date">Document Date*</label>
              <input
                type="Date"
                required="required"
                name="docDate"
                onChange={handleChange}
                value={ewayBill.docDate}
              />
            </div>
            <div>
              <label htmlFor="transactionType">Transaction Type*</label>
              <select
                name="transactionType"
                required="required"
                id="TransactionType"
                onChange={handleChange}
                value={ewayBill.transactionType}
                type="number"
              >
                {" "}
                <option value={0} name="transactionType">
                  -----
                </option>
                <option value={1} name="transactionType">
                  Regular
                </option>
                <option value={2} name="transactionType">
                  Bill To -Ship To
                </option>
                <option value={3} name="transactionType">
                  Bill From -Dispatch From
                </option>
                <option value={4} name="transactionType">
                  Combiation of 2 and 3
                </option>
              </select>
            </div>
          </div>

          <div className="third">
            <div className="div-third">
              {/* <div className="third-first"> */}
              <div className="one">
                <h2 className="mainText">Bill From</h2>
              </div>
              <div className="two">
                <div className="name">
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    name="fromTrdName"
                    onChange={handleChange}
                    value={ewayBill.fromTrdName}
                  />
                </div>
                <div className="gstin">
                  <label htmlFor="gstin">GSITN*</label>
                  <input
                    type="text"
                    required="required"
                    name="fromGstin"
                    onChange={handleChange}
                    value={ewayBill.fromGstin}
                  />
                </div>
                <div className="state">
                  <label htmlFor="fromStateCode">State*</label>
                  <select
                    required="required"
                    name="fromStateCode"
                    id="state"
                    className="form-control"
                    onChange={handleChange}
                    value={ewayBill.fromStateCode}
                  >
                    <option value="" name="state">
                      state
                    </option>
                    <option name="fromStateCode" value="37">
                      Andhra Pradesh
                    </option>
                    <option name="fromStateCode" value="35">
                      Andaman and Nicobar Islands
                    </option>
                    <option name="fromStateCode" value="12">
                      Arunachal Pradesh
                    </option>
                    <option name="fromStateCode" value="18">
                      Assam
                    </option>
                    <option name="fromStateCode" value="10">
                      Bihar
                    </option>
                    <option name="fromStateCode" value="4">
                      Chandigarh
                    </option>
                    <option name="fromStateCode" value="22">
                      Chhattisgarh
                    </option>
                    <option name="fromStateCode" value="26">
                      Dadar and Nagar Haveli
                    </option>
                    <option name="fromStateCode" value="25">
                      Daman and Diu
                    </option>
                    <option name="fromStateCode" value="7">
                      Delhi
                    </option>
                    <option name="fromStateCode" value="31">
                      Lakshadweep
                    </option>
                    <option name="fromStateCode" value="34">
                      Puducherry
                    </option>
                    <option name="fromStateCode" value="30">
                      Goa
                    </option>
                    <option name="fromStateCode" value="24">
                      Gujarat
                    </option>
                    <option name="fromStateCode" value="6">
                      Haryana
                    </option>
                    <option name="fromStateCode" value="2">
                      Himachal Pradesh
                    </option>
                    <option name="fromStateCode" value="1">
                      Jammu and Kashmir
                    </option>
                    <option name="fromStateCode" value="20">
                      Jharkhand
                    </option>
                    <option name="fromStateCode" value="29">
                      Karnataka
                    </option>
                    <option name="fromStateCode" value="32">
                      Kerala
                    </option>
                    <option name="fromStateCode" value="23">
                      Madhya Pradesh
                    </option>
                    <option name="fromStateCode" value="27">
                      Maharashtra
                    </option>
                    <option name="fromStateCode" value="14">
                      Manipur
                    </option>
                    <option name="fromStateCode" value="17">
                      Meghalaya
                    </option>
                    <option name="fromStateCode" value="15">
                      Mizoram
                    </option>
                    <option name="fromStateCode" value="13">
                      Nagaland
                    </option>
                    <option name="fromStateCode" value="21">
                      Odisha
                    </option>
                    <option name="fromStateCode" value="99">
                      Other Countries
                    </option>
                    <option name="fromStateCode" value="97">
                      Other Territory
                    </option>
                    <option name="fromStateCode" value="3">
                      Punjab
                    </option>
                    <option name="fromStateCode" value="8">
                      Rajasthan
                    </option>
                    <option name="fromStateCode" value="11">
                      Sikkim
                    </option>
                    <option name="fromStateCode" value="33">
                      Tamil Nadu
                    </option>
                    <option name="fromStateCode" value="36">
                      Telangana
                    </option>
                    <option name="fromStateCode" value="16">
                      Tripura
                    </option>
                    <option name="fromStateCode" value="9">
                      Uttar Pradesh
                    </option>
                    <option name="fromStateCode" value="5">
                      Uttarakhand
                    </option>
                    <option name="fromStateCode" value="19">
                      West Bengal
                    </option>
                  </select>
                </div>
              </div>
              {/* </div> */}
            </div>
            <div className="div-third">
              <div className="one">
                <h2 className="mainText">Dispatch From</h2>
              </div>
              <div className="two">
                <div>
                  <label htmlFor="address">Address</label>
                  <input
                    type="text"
                    name="fromAddr1"
                    onChange={handleChange}
                    value={ewayBill.fromAddr1}
                  />
                </div>
                <div className="place">
                  <label htmlFor="place">Place</label>
                  <input
                    type="text"
                    name="fromPlace"
                    onChange={handleChange}
                    value={ewayBill.fromPlace}
                  />
                </div>
                <div className="pincode">
                  <label htmlFor="pincode">Pincode*</label>
                  <input
                    type="number"
                    name="fromPincode"
                    required="required"
                    onChange={handleChange}
                    value={ewayBill.fromPincode}
                  />

                  <select
                    name="actFromStateCode"
                    required="required"
                    id="state"
                    className="form-control"
                    onChange={handleChange}
                    value={ewayBill.actFromStateCode}
                  >
                    <option value="" name="actFromStateCode">
                      state
                    </option>
                    <option name="actFromStateCode" value="37">
                      Andhra Pradesh
                    </option>
                    <option name="actFromStateCode" value="35">
                      Andaman and Nicobar Islands
                    </option>
                    <option name="actFromStateCode" value="12">
                      Arunachal Pradesh
                    </option>
                    <option name="actFromStateCode" value="18">
                      Assam
                    </option>
                    <option name="actFromStateCode" value="10">
                      Bihar
                    </option>
                    <option name="actFromStateCode" value="4">
                      Chandigarh
                    </option>
                    <option name="actFromStateCode" value="22">
                      Chhattisgarh
                    </option>
                    <option name="actFromStateCode" value="26">
                      Dadar and Nagar Haveli
                    </option>
                    <option name="actFromStateCode" value="25">
                      Daman and Diu
                    </option>
                    <option name="actFromStateCode" value="7">
                      Delhi
                    </option>
                    <option name="actFromStateCode" value="31">
                      Lakshadweep
                    </option>
                    <option name="actFromStateCode" value="34">
                      Puducherry
                    </option>
                    <option name="actFromStateCode" value="30">
                      Goa
                    </option>
                    <option name="actFromStateCode" value="24">
                      Gujarat
                    </option>
                    <option name="actFromStateCode" value="6">
                      Haryana
                    </option>
                    <option name="actFromStateCode" value="2">
                      Himachal Pradesh
                    </option>
                    <option name="actFromStateCode" value="1">
                      Jammu and Kashmir
                    </option>
                    <option name="actFromStateCode" value="20">
                      Jharkhand
                    </option>
                    <option name="actFromStateCode" value="29">
                      Karnataka
                    </option>
                    <option name="actFromStateCode" value="32">
                      Kerala
                    </option>
                    <option name="actFromStateCode" value="23">
                      Madhya Pradesh
                    </option>
                    <option name="actFromStateCode" value="27">
                      Maharashtra
                    </option>
                    <option name="actFromStateCode" value="14">
                      Manipur
                    </option>
                    <option name="actFromStateCode" value="17">
                      Meghalaya
                    </option>
                    <option name="actFromStateCode" value="15">
                      Mizoram
                    </option>
                    <option name="actFromStateCode" value="13">
                      Nagaland
                    </option>
                    <option name="actFromStateCode" value="21">
                      Odisha
                    </option>
                    <option name="actFromStateCode" value="99">
                      Other Countries
                    </option>
                    <option name="actFromStateCode" value="97">
                      Other Territory
                    </option>
                    <option name="actFromStateCode" value="3">
                      Punjab
                    </option>
                    <option name="actFromStateCode" value="8">
                      Rajasthan
                    </option>
                    <option name="actFromStateCode" value="11">
                      Sikkim
                    </option>
                    <option name="actFromStateCode" value="33">
                      Tamil Nadu
                    </option>
                    <option name="actFromStateCode" value="36">
                      Telangana
                    </option>
                    <option name="actFromStateCode" value="16">
                      Tripura
                    </option>
                    <option name="actFromStateCode" value="9">
                      Uttar Pradesh
                    </option>
                    <option name="actFromStateCode" value="5">
                      Uttarakhand
                    </option>
                    <option name="actFromStateCode" value="19">
                      West Bengal
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div className="fourth">
            <div className="div-third">
              <div className="one">
                <h3 className="mainText">Bill To</h3>
              </div>
              <div className="two">
                <div>
                  <label htmlFor="name">Name</label>
                  <input
                    type="text"
                    name="toTrdName"
                    onChange={handleChange}
                    value={ewayBill.toTrdName}
                  />
                </div>
                <div>
                  <label htmlFor="GSTIN">GSTIN*</label>
                  <input
                    type="text"
                    required="required"
                    name="toGstin"
                    onChange={handleChange}
                    value={ewayBill.toGstin}
                  />
                </div>
                <div>
                  <label htmlFor="toStateCode">State*</label>
                  <select
                    name="toStateCode"
                    id="state"
                    className="form-control"
                    required="required"
                    onChange={handleChange}
                    value={ewayBill.toStateCode}
                  >
                    <option value="" name="toStateCode">
                      state
                    </option>
                    <option name="toStateCode" value="37">
                      Andhra Pradesh
                    </option>
                    <option name="toStateCode" value="35">
                      Andaman and Nicobar Islands
                    </option>
                    <option name="toStateCode" value="12">
                      Arunachal Pradesh
                    </option>
                    <option name="toStateCode" value="18">
                      Assam
                    </option>
                    <option name="toStateCode" value="10">
                      Bihar
                    </option>
                    <option name="toStateCode" value="4">
                      Chandigarh
                    </option>
                    <option name="toStateCode" value="22">
                      Chhattisgarh
                    </option>
                    <option name="toStateCode" value="26">
                      Dadar and Nagar Haveli
                    </option>
                    <option name="toStateCode" value="25">
                      Daman and Diu
                    </option>
                    <option name="toStateCode" value="7">
                      Delhi
                    </option>
                    <option name="toStateCode" value="31">
                      Lakshadweep
                    </option>
                    <option name="toStateCode" value="34">
                      Puducherry
                    </option>
                    <option name="toStateCode" value="30">
                      Goa
                    </option>
                    <option name="toStateCode" value="24">
                      Gujarat
                    </option>
                    <option name="toStateCode" value="6">
                      Haryana
                    </option>
                    <option name="toStateCode" value="2">
                      Himachal Pradesh
                    </option>
                    <option name="toStateCode" value="1">
                      Jammu and Kashmir
                    </option>
                    <option name="toStateCode" value="20">
                      Jharkhand
                    </option>
                    <option name="toStateCode" value="29">
                      Karnataka
                    </option>
                    <option name="toStateCode" value="32">
                      Kerala
                    </option>
                    <option name="toStateCode" value="23">
                      Madhya Pradesh
                    </option>
                    <option name="toStateCode" value="27">
                      Maharashtra
                    </option>
                    <option name="toStateCode" value="14">
                      Manipur
                    </option>
                    <option name="toStateCode" value="17">
                      Meghalaya
                    </option>
                    <option name="toStateCode" value="15">
                      Mizoram
                    </option>
                    <option name="toStateCode" value="13">
                      Nagaland
                    </option>
                    <option name="toStateCode" value="21">
                      Odisha
                    </option>
                    <option name="toStateCode" value="99">
                      Other Countries
                    </option>
                    <option name="toStateCode" value="97">
                      Other Territory
                    </option>
                    <option name="toStateCode" value="3">
                      Punjab
                    </option>
                    <option name="toStateCode" value="8">
                      Rajasthan
                    </option>
                    <option name="toStateCode" value="11">
                      Sikkim
                    </option>
                    <option name="toStateCode" value="33">
                      Tamil Nadu
                    </option>
                    <option name="toStateCode" value="36">
                      Telangana
                    </option>
                    <option name="toStateCode" value="16">
                      Tripura
                    </option>
                    <option name="toStateCode" value="9">
                      Uttar Pradesh
                    </option>
                    <option name="toStateCode" value="5">
                      Uttarakhand
                    </option>
                    <option name="toStateCode" value="19">
                      West Bengal
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div className="div-third">
              <div className="one">
                <h3 className="mainText">Ship To</h3>
              </div>
              <div className="two">
                <div className="">
                  <label htmlFor="address">Address</label>
                  <input
                    onChange={handleChange}
                    value={ewayBill.toAddr1}
                    type="text"
                    name="toAddr1"
                  />
                </div>
                <div className="place">
                  <label htmlFor="place">Place</label>
                  <input
                    onChange={handleChange}
                    value={ewayBill.toPlace}
                    type="text"
                    name="toPlace"
                  />
                </div>
                <div className="pincode">
                  <label htmlFor="pincode">Pincode*</label>
                  <input
                    required="required"
                    onChange={handleChange}
                    value={ewayBill.toPincode}
                    type="number"
                    name="toPincode"
                  />
                  <select
                    required="required"
                    name="actToStateCode"
                    id="state"
                    className="form-control"
                    onChange={handleChange}
                    value={ewayBill.actToStateCode}
                  >
                    <option value="" name="actToStateCode">
                      State
                    </option>
                    <option name="actToStateCode" value="37">
                      Andhra Pradesh
                    </option>
                    <option name="actToStateCode" value="35">
                      Andaman and Nicobar Islands
                    </option>
                    <option name="actToStateCode" value="12">
                      Arunachal Pradesh
                    </option>
                    <option name="actToStateCode" value="18">
                      Assam
                    </option>
                    <option name="actToStateCode" value="10">
                      Bihar
                    </option>
                    <option name="actToStateCode" value="4">
                      Chandigarh
                    </option>
                    <option name="actToStateCode" value="22">
                      Chhattisgarh
                    </option>
                    <option name="actToStateCode" value="26">
                      Dadar and Nagar Haveli
                    </option>
                    <option name="actToStateCode" value="25">
                      Daman and Diu
                    </option>
                    <option name="actToStateCode" value="7">
                      Delhi
                    </option>
                    <option name="actToStateCode" value="31">
                      Lakshadweep
                    </option>
                    <option name="actToStateCode" value="34">
                      Puducherry
                    </option>
                    <option name="actToStateCode" value="30">
                      Goa
                    </option>
                    <option name="actToStateCode" value="24">
                      Gujarat
                    </option>
                    <option name="actToStateCode" value="6">
                      Haryana
                    </option>
                    <option name="actToStateCode" value="2">
                      Himachal Pradesh
                    </option>
                    <option name="actToStateCode" value="1">
                      Jammu and Kashmir
                    </option>
                    <option name="actToStateCode" value="20">
                      Jharkhand
                    </option>
                    <option name="actToStateCode" value="29">
                      Karnataka
                    </option>
                    <option name="actToStateCode" value="32">
                      Kerala
                    </option>
                    <option name="actToStateCode" value="23">
                      Madhya Pradesh
                    </option>
                    <option name="actToStateCode" value="27">
                      Maharashtra
                    </option>
                    <option name="actToStateCode" value="14">
                      Manipur
                    </option>
                    <option name="actToStateCode" value="17">
                      Meghalaya
                    </option>
                    <option name="actToStateCode" value="15">
                      Mizoram
                    </option>
                    <option name="actToStateCode" value="13">
                      Nagaland
                    </option>
                    <option name="actToStateCode" value="21">
                      Odisha
                    </option>
                    <option name="actToStateCode" value="99">
                      Other Countries
                    </option>
                    <option name="actToStateCode" value="97">
                      Other Territory
                    </option>
                    <option name="actToStateCode" value="3">
                      Punjab
                    </option>
                    <option name="actToStateCode" value="8">
                      Rajasthan
                    </option>
                    <option name="actToStateCode" value="11">
                      Sikkim
                    </option>
                    <option name="actToStateCode" value="33">
                      Tamil Nadu
                    </option>
                    <option name="actToStateCode" value="36">
                      Telangana
                    </option>
                    <option name="actToStateCode" value="16">
                      Tripura
                    </option>
                    <option name="actToStateCode" value="9">
                      Uttar Pradesh
                    </option>
                    <option name="actToStateCode" value="5">
                      Uttarakhand
                    </option>
                    <option name="actToStateCode" value="19">
                      West Bengal
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <h3 className="mainText">Item Details</h3>

          <div className="fifth">
            <table>
              <thead>
                <tr>
                  <th>Product Name</th>
                  <th>Description</th>
                  <th>HSN*</th>
                  <th>Quantity</th>
                  <th>Unit </th>
                  <th>Rate</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input
                      type="text"
                      name="productName"
                      onChange={handleChange}
                      value={ewayBill.productName}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="productDesc"
                      onChange={handleChange}
                      value={ewayBill.productDesc}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="hsnCode"
                      onChange={handleChange}
                      value={ewayBill.hsnCode}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="quantity"
                      onChange={handleChange}
                      value={ewayBill.quantity}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="qtyUnit"
                      onChange={handleChange}
                      value={ewayBill.qtyUnit}
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="rate"
                      onChange={handleChange}
                      value={ewayBill.rate}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
            <table>
              <thead>
                <tr>
                  <th>Value/Taxable Value (Rs.)*</th>
                  <th>CGST+ SGST Rate(%) </th>
                  <th>IGST Rate(%)</th>
                  <th>CESS Advol Rate(%)</th>
                  <th>CESS non.Advol. Rate</th>
                  <th>
                    <button>+</button>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input
                      type="text"
                      name="taxableAmount"
                      onChange={handleChange}
                      value={ewayBill.taxableAmount}
                      placeholder={ewayBill.rate * ewayBill.quantity}
                    />
                  </td>
                  <td>
                    <select
                      className="selectt"
                      name="sgstRate"
                      id="document-type"
                      onChange={handleChange}
                      value={ewayBill.sgstRate}
                    >
                      <option name="sgstRate" value="-1">
                        -Select-
                      </option>
                      <option name="sgstRate" value="0.500">
                        0.500 + 0.500
                      </option>
                      <option name="sgstRate" value="0.750">
                        0.750 + 0.750
                      </option>
                      <option name="sgstRate" value="3.750">
                        3.750 + 3.750
                      </option>
                      <option name="sgstRate" value="0.000">
                        0 + 0{" "}
                      </option>
                      <option name="sgstRate" value="2.500">
                        2.500 + 2.500
                      </option>
                      <option name="sgstRate" value="6.000">
                        6 + 6{" "}
                      </option>
                      <option name="sgstRate" value="9.000">
                        9 + 9{" "}
                      </option>
                      <option name="sgstRate" value="14.000">
                        14 + 14{" "}
                      </option>
                      <option name="sgstRate" value="1.500">
                        1.500 + 1.500
                      </option>
                      <option name="sgstRate" value="0.050">
                        0.050 + 0.050
                      </option>
                      <option name="sgstRate" value="0.125">
                        0.125 + 0.125
                      </option>
                      <option name="sgstRate" value="3.000">
                        3 + 3{" "}
                      </option>
                      <option name="sgstRate" value="-2">
                        -Not Appl-
                      </option>
                    </select>
                  </td>
                  <td>
                    <select
                      className="selectt"
                      name="igstRate"
                      id="document-type"
                      onChange={handleChange}
                      value={ewayBill.igstRate}
                    >
                      <option name="igstRate" value="-1">
                        -Select-
                      </option>
                      <option name="igstRate" value="1.000">
                        1
                      </option>
                      <option name="igstRate" value="1.500">
                        1.500
                      </option>
                      <option name="igstRate" value="7.500">
                        7.500
                      </option>
                      <option name="igstRate" value="0.000">
                        0
                      </option>
                      <option name="igstRate" value="5.000">
                        5
                      </option>
                      <option name="igstRate" value="12.000">
                        12
                      </option>
                      <option name="igstRate" value="18.000">
                        18
                      </option>
                      <option name="igstRate" value="28.000">
                        28
                      </option>
                      <option name="igstRate" value="3.000">
                        3
                      </option>
                      <option name="igstRate" value="0.100">
                        0.100
                      </option>
                      <option name="igstRate" value="0.250">
                        0.250
                      </option>
                      <option name="igstRate" value="6.000">
                        6
                      </option>
                      <option name="igstRate" value="-2">
                        -Not Appl-
                      </option>
                    </select>
                  </td>
                  <td>
                    <select
                      className="selectt"
                      name="cessRate"
                      id="document-type"
                      onChange={handleChange}
                      value={ewayBill.cessRate}
                    >
                      <option value="-1">-Select-</option>
                      <option value="0.000" name="cessRate">
                        0
                      </option>
                      <option name="cessRate" value="1.000">
                        1
                      </option>
                      <option name="cessRate" value="3.000">
                        3
                      </option>
                      <option name="cessRate" value="5.000">
                        5
                      </option>
                      <option name="cessRate" value="11.000">
                        11
                      </option>
                      <option name="cessRate" value="12.000">
                        12
                      </option>
                      <option name="cessRate" value="12.500">
                        12.500
                      </option>
                      <option name="cessRate" value="15.000">
                        15
                      </option>
                      <option name="cessRate" value="17.000">
                        17
                      </option>
                      <option name="cessRate" value="20.000">
                        20
                      </option>
                      <option name="cessRate" value="21.000">
                        21
                      </option>
                      <option name="cessRate" value="22.000">
                        22
                      </option>
                      <option name="cessRate" value="36.000">
                        36
                      </option>
                      <option name="cessRate" value="49.000">
                        49
                      </option>
                      <option name="cessRate" value="60.000">
                        60
                      </option>
                      <option name="cessRate" value="61.000">
                        61
                      </option>
                      <option name="cessRate" value="65.000">
                        65
                      </option>
                      <option name="cessRate" value="71.000">
                        71
                      </option>
                      <option name="cessRate" value="72.000">
                        72
                      </option>
                      <option name="cessRate" value="89.000">
                        89
                      </option>
                      <option name="cessRate" value="96.000">
                        96
                      </option>
                      <option name="cessRate" value="142.000">
                        142
                      </option>
                      <option name="cessRate" value="160.000">
                        160
                      </option>
                      <option name="cessRate" value="204.000">
                        204
                      </option>
                      <option name="cessRate" value="290.000">
                        290
                      </option>
                      <option name="cessRate" value="-2">
                        -Not Appl-
                      </option>
                    </select>
                  </td>
                  <td>
                    {/* <input
                    type="text"
                    name="Item_Details_CESS_NonAdvol_Rate"
                    onChange={handleChange}
                    value={ewayBill.Item_Details_CESS_NonAdvol_Rate}
                  /> */}
                    <select
                      className="selectt"
                      name="cessNonAdvol"
                      id="document-type"
                      onChange={handleChange}
                      value={ewayBill.cessNonAdvol}
                    >
                      <option name="cessNonAdvol" value="-1">
                        -Select-
                      </option>
                      <option name="cessNonAdvol" value="0.000">
                        0
                      </option>
                      <option name="cessNonAdvol" value="400.000">
                        400
                      </option>
                      <option name="cessNonAdvol" value="2076.000">
                        2076
                      </option>
                      <option name="cessNonAdvol" value="2747.000">
                        2747
                      </option>
                      <option name="cessNonAdvol" value="3668.000">
                        3668
                      </option>
                      <option name="cessNonAdvol" value="4006.000">
                        4006
                      </option>
                      <option name="cessNonAdvol" value="4170.000">
                        4170
                      </option>
                      <option name="cessNonAdvol" value="-2">
                        -Not Appl-
                      </option>
                    </select>
                  </td>
                  <td>
                    <button>no</button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="second-table">
              <table>
                <thead>
                  <tr>
                    <th>Total Tax'ble Amount</th>
                    <th>
                      CGST Amount -{" "}
                      {(ewayBill.sgstRate * ewayBill.taxableAmount) / 100}
                    </th>
                    <th>
                      SGST Amount -{" "}
                      {(ewayBill.sgstRate * ewayBill.taxableAmount) / 100}
                    </th>
                    <th>
                      IGST Amount -{" "}
                      {(ewayBill.igstRate * ewayBill.taxableAmount) / 100}
                    </th>
                    <th>
                      CESS Advol Amount -{" "}
                      {(ewayBill.cessRate * ewayBill.taxableAmount) / 100}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <input
                        type="text"
                        name="totalValue"
                        onChange={handleChange}
                        value={ewayBill.totalValue}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        name="cgstValue"
                        onChange={handleChange}
                        value={ewayBill.cgstValue}
                        placeholder={
                          (ewayBill.sgstRate * ewayBill.taxableAmount) / 100
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        name="sgstValue"
                        onChange={handleChange}
                        value={ewayBill.sgstValue}
                        placeholder={
                          (ewayBill.sgstRate * ewayBill.taxableAmount) / 100
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        name="igstValue"
                        onChange={handleChange}
                        value={ewayBill.igstValue}
                        placeholder={
                          (ewayBill.igstRate * ewayBill.taxableAmount) / 100
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        onChange={handleChange}
                        value={ewayBill.cessValue}
                        name="cessValue"
                        placeholder={
                          (ewayBill.cessRate * ewayBill.taxableAmount) / 100
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="second-table">
              <table>
                <thead>
                  <tr>
                    <th>CESS Non Advol Amount </th>
                    <th>Other Amount(+/-) </th>
                    <th>Total Inv. Amount </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <input
                        value={ewayBill.TolNonAdolVal}
                        name="TolNonAdolVal"
                        type="text"
                        onChange={handleChange}
                        placeholder={ewayBill.cessNonAdvol}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        name="OthValue"
                        onChange={handleChange}
                        value={ewayBill.OthValue}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        required="required"
                        name="totInvValue"
                        onChange={handleChange}
                        value={ewayBill.totInvValue}
                        placeholder={
                          Number(ewayBill.taxableAmount) +
                          Number(ewayBill.cgstValue) +
                          Number(ewayBill.sgstValue) +
                          Number(ewayBill.igstValue) +
                          Number(ewayBill.cessValue) +
                          Number(ewayBill.TolNonAdolVal) +
                          Number(ewayBill.OthValue)
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <h3 className="mainText">Transportation Details</h3>
          <div className="six">
            <div>
              <label htmlFor=" transporterId">Transporter ID</label>
              <input
                type="text"
                name="transporterId"
                onChange={handleChange}
                value={ewayBill.transporterId}
              />
            </div>
            <div>
              <label htmlFor="transporterName"> Transporter Name</label>
              <input
                name="transporterName"
                onChange={handleChange}
                value={ewayBill.transporterName}
                type="text"
              />
            </div>
            <div>
              <label htmlFor="pin">Auto Calculated PIN to PIN (in KM)</label>
              {/* <input
              type="text"
              name="pin"
              onChange={handleChange}
              value={ewayBill.transDistance}
            /> */}
            </div>
            <div>
              <label htmlFor="distance">Approximate Distance (in KM)*</label>
              <input
                type="text"
                name="transDistance"
                required="required"
                onChange={handleChange}
                value={ewayBill.transDistance}
              />
            </div>
          </div>
          <h3 className="mainText">Part B</h3>
          <div className="seven">
            <div className="seven-left">
              <div className="Transaction-left">
                <div>
                  <h4>Mode : </h4>
                </div>
                <div style={{ gap: "5px" }}>
                  <input
                    type="radio"
                    name="transMode"
                    id="Road"
                    value="1"
                    onChange={handleChange}
                  />
                  <label htmlFor="transMode">Road</label>
                  <input
                    type="radio"
                    name="transMode"
                    id="Rail  "
                    value="2"
                    onChange={handleChange}
                  />
                  <label htmlFor="transMode">Rail</label>
                  <input
                    type="radio"
                    name="transMode"
                    id="Air  "
                    value="3"
                    onChange={handleChange}
                  />
                  <label htmlFor="transMode">Air</label>
                  <input
                    type="radio"
                    name="transMode"
                    id="ship  "
                    value="4"
                    onChange={handleChange}
                  />
                  <label htmlFor="transMode">Ship or Ship Cum Road/Rail</label>
                </div>
              </div>
              <div className="left-lower">
                <label htmlFor="vehicleNo">Vehical No</label>
                <input
                  type="text"
                  name="vehicleNo"
                  onChange={handleChange}
                  value={ewayBill.vehicleNo}
                />
              </div>
            </div>
            <div className="seven-right">
              <div className="Transaction-right">
                <h4>Vehicle Type</h4>
                <input
                  type="radio"
                  name="vehicleType "
                  id="Regular"
                  value="R"
                  onChange={handleChange}
                />
                <label htmlFor="vehicleType">Regular</label>
                <input
                  type="radio"
                  name="vehicleType "
                  id="Cargo  "
                  value="O"
                  onChange={handleChange}
                />
                <label htmlFor=" vehicleType">Over Dimensional Cargo </label>
              </div>
              <div className="right-lower">
                <label htmlFor="Airway Bill">Transporter Doc. No. & Date</label>
                <input
                  type="text"
                  name="transDocNo"
                  onChange={handleChange}
                  value={ewayBill.transDocNo}
                />
                {/* <label htmlFor="Document Date">Document Date</label> */}
                <input
                  type="Date"
                  name="transDocDate"
                  onChange={handleChange}
                  value={ewayBill.transDocDate}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="btn">
          <button className="button button1">Submit</button>
          {/* <ReactToPrint
            trigger={() => (
              <h2 style={{ cursor: "pointer", marginTop: "10px" }}>
                <button onClick={() => printChallan()}>
                  For Print Click Here{" "}
                </button>
              </h2>
            )}
            content={() => componentRef}
          /> */}
          {/* <button onClick={() => printChallan()}>For Print Click Here </button> */}
        </div>
      </form>
      {/* <Modal
        open={open2}
        onClose={handleClose2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style2}>
          <>
            <div>
              <h1>hello</h1>
            </div>
          </>
        </Box>
      </Modal> */}
    </div>
  );
};

export default EwayBill;
